import React from "react";
// Import Link
import { Link } from "react-router-dom";
// import Img
import Img from "../../../src/assets/img/airplane.png";

const TravelConsultingText = () => {
  return (
    <>
      <section id="about_us_top" className="section_padding">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="about_us_left">
                {/* <h5>About us</h5> */}
                <h2>Travel Consulting</h2>
                <p>
                Travel consulting at House of Polani is about crafting experiences that perfectly align with your vision. Our expert consultants bring decades of combined experience to the table, offering insights and recommendations that transform ordinary trips into extraordinary journeys. We believe in creating travel experiences that not only meet but exceed expectations, whether you're planning a leisure trip, business journey, or special event.

                </p>
                <p>
                Our approach to travel consulting begins with understanding your unique preferences and requirements. We take the time to learn about your travel style, preferences, and objectives, allowing us to create perfectly tailored itineraries. Our consultants leverage their extensive knowledge of global destinations to provide insider tips and recommendations that enhance your travel experience. From selecting the perfect accommodations to arranging special experiences, we ensure every detail is thoughtfully planned.
                </p>
                <p>
                Beyond just planning, we provide comprehensive support throughout your journey. Our team remains available 24/7 to handle any situations that may arise during your travels. We also assist with travel insurance selection, loyalty program optimization, and special requests, ensuring you receive maximum value and peace of mind with every journey.
                {" "}
                </p>
                {/* <Link to="#!" className="btn btn_theme btn_sm">
                  More
                </Link> */}
              </div>
            </div>
            {/* <div className="col-lg-6">
              <div className="about_us_right">
                <img src={Img} />
              </div>
            </div> */}
          </div>
        </div>
      </section>
    </>
  );
};

export default TravelConsultingText;
